import { InputSearch } from 'ui/inputs';
import { BillingDateRangePicker } from '../Index/BillingDateRangePicker';
import { useSimpleIndexContext } from '../SimpleIndexPage/contexts';
import { Wrapper } from './PageActions.styled';

export const PageActions = () => {
  const { query, setQuery } = useSimpleIndexContext();

  return (
    <Wrapper>
      <BillingDateRangePicker />
      <InputSearch
        id="table-search-input"
        data-test="table-search-input"
        placeholder="Search..."
        value={query}
        onChange={setQuery}
        handleClear={() => {
          setQuery('');
        }}
      />
    </Wrapper>
  );
};
